<template>
  <!-- pb20 -->
  <div id="defaultId1" class="company_detail ">
<div :class="isMenban?'operations-div':''">
  <gui_card
      id="ge6845"
      class="uc1096 mb10"
      label=""
      :isShowLabel="false"
    >
      <div >
        <h2 class="operations-head-content">
          <span class="operations-head ">{{ $t('Sanctions.Sanctions') }}</span>
        </h2>
  
        <h4  class="head-titeltwo"> {{ $t('Sanctions.Potentialcompliancerisks') }}</h4>
    
      </div>
    
    </gui_card>
    <!-- <gui_card v-if="EntityData?.length > 0"
      id="ge6845"
      class="uc1096 mb10"
      label=""
      :isShowLabel="false"
    >
      <div>
        <h2 class="operations-head">
          <span class="head-titel detail_title_20">Entity Info </span>
        </h2>
        <div class="table-biao" style="margin-top: 20px">
          <el-table :data="EntityData" style="width: 100%" empty-text="No Data" class="table_height_30 table_font_size_14 table_contentHeight_40">
            <el-table-column
              prop="Action"
              label="Action ID"
              width="300"
              align="left"
            >
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row.actionId }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="Name" label="Company Name" align="left">
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="State"
              label="Status"
              width="245"
              align="left"
            >
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row.state }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="Date" label="Date Type" align="left">
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row.dateType }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="Incorporation"
              label="Date of Sanction"
              align="left"
            >
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row.dateOfIncorporation }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
       
      </div>
    </gui_card> -->
    <!-- <gui_card v-if="NameData?.length > 0"
      id="ge6845"
      class="uc1096 mb10"
      label=""
      :isShowLabel="false"
    >
      <div>
        <h2 class="operations-head">
          <span class="head-titel detail_title_20">Name Info </span>
        </h2>
        <div class="table-biao" style="margin-top: 20px">
          <el-table :data="NameData" style="width: 100%" class="table_height_30 table_font_size_14 table_contentHeight_40">
            <el-table-column prop="nameType" label="Name Type" align="left">
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row.nameType }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="nameSubType" label="Name Subtype" align="left">
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row.nameSubType }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="Name" align="left">
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row.name }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
   
      </div>
    </gui_card> -->
    <gui_card 
      id="ge6845"
      class="uc1096 mb10"
      label=""
      :isShowLabel="false"
    >
      <div>
        <h2 class="operations-head-content">
          <span class="operations-head ">{{ $t('Sanctions.IDInfo') }} </span>
        </h2>
        <div class="table-biao" >
          <el-table :data="IDData" style="width: 100%" class="table_height_30 table_font_size_14 table_contentHeight_40">
            <el-table-column
              prop="numberType"
              :label="$t('Sanctions.IDType') "
              align="left"
              show-overflow-tooltip
              class="tb-head"
            >
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row.numberType }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="number"
              :label="$t('Sanctions.IDInfo') "
              align="left"
              show-overflow-tooltip
              class="tb-head" 
            >
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row.number }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="numberDescription"
                :label="$t('Sanctions.IDDescription') "
              show-overflow-tooltip
              class="tb-head" 
              align="left"
            >
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row.numberDescription }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </gui_card>
    <!-- <gui_card v-if="sourceItems?.length > 0"
      id="ge6845"
      class="uc1096 mb10"
      label=""
      :isShowLabel="false"
    >
      <div>
        <h2 class="operations-head">
          <span class="head-titel detail_title_20">Registration & Address Info </span>
        </h2>
        <div class="table-biao" style="margin-top: 20px">
          <el-table :data="RegisteData" style="width: 100%" class="table_height_30 table_font_size_14 table_contentHeight_40">
            <el-table-column prop="countryType" label="Country Type" align="left">
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row.countryType }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="countryCode" label="Country Code" align="left">
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row.countryCode }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
           <div class="table-biao" style="margin-top: 40px">
          <el-table :data="AddressDate" style="width: 100%" class="table_height_30 table_font_size_14 table_contentHeight_40">
            <el-table-column prop="address" width="650" label="Address" align="left">
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row.address }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="country"  label="Country" align="left">
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row.country }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="regionAndPostalCode"
              label="Region, Post Code"
              align="left"
            >
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row.regionAndPostalCode }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sourceWebsite" label="Source" align="left">
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row.sourceWebsite }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
    
      </div>
    </gui_card> -->
     <gui_card 
      id="ge6845"
      class="uc1096 mb10"
      label=""
      :isShowLabel="false"
    >
      <div>
        <h2 class="operations-head-content">
          <span class="operations-head ">{{ $t('Sanctions.SanctionList') }}</span>
        </h2>
        <div class="table-biao table_X"  >
          <el-table :data="SanctionData" style="width: 100%" class="table_height_30 table_font_size_14 table_contentHeight_40">
            <el-table-column
              prop="listOfSanctionsInvolved"
               :label="$t('Sanctions.SanctionListInvolved') "
              align="left"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row.listOfSanctionsInvolved }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="startDate"
               :label="$t('Sanctions.StartDate') "
              align="left"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row.startDate }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="endDate"
             :label="$t('Sanctions.EndDate') "
              align="left"
                width="250"
                show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row.endDate }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </gui_card>
    <gui_card  v-if="sourceItems?.length > 0"
      id="ge6845"
      class="uc1096 mb10"
      label=""
      :isShowLabel="false"
    >
      <div>
        <h2 class="operations-head-content">
          <span class="operations-head  ">{{ $t('Sanctions.SourceList') }}  </span>
        </h2>
        <div class="table-biao"   v-for="(item, index) in sourceItems" :key="index">
          <div class="Source-item">
            <div class="Source-height"><span class="Source-left">{{$t('Sanctions.SourceName') }} </span> <span class="Source-right">{{ item.sourceName }}</span></div>
            <div class="Source-height">
              <span class="Source-left">{{$t('Sanctions.ProfileNotes') }}</span> <span class="Source-right" v-html="formattedString(item.profileNotes)"></span>
            </div >
            <div class="Source-height">
              <span class="Source-left">{{$t('Sanctions.Link') }}</span> <span class="Source-right" ><a style="display: flex; color: #1290c9;" :href="item.sourceName" target="_blank"><svg  t="1719569156089" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7692" width="36" height="36"><path d="M901.850593 926.476283a48.761858 48.761858 0 0 1-48.761859 48.761859H170.422718a48.761858 48.761858 0 0 1-48.761858-48.761859V48.762834a48.761858 48.761858 0 0 1 48.761858-48.761859h418.864363a48.761858 48.761858 0 0 1 34.620919 14.140939l263.801654 263.801654a48.761858 48.761858 0 0 1 14.140939 34.620919V926.476283z" fill="#EBECF0" p-id="7693"></path><path d="M901.850593 926.476283v48.761859a48.761858 48.761858 0 0 1-48.761859 48.761858H170.422718a48.761858 48.761858 0 0 1-48.761858-48.761858v-48.761859a48.761858 48.761858 0 0 0 48.761858 48.761859h682.666016a48.761858 48.761858 0 0 0 48.761859-48.761859z" fill="#C1C7D0" p-id="7694"></path><path d="M24.137143 536.381417h975.237166v243.809291a48.761858 48.761858 0 0 1-48.761858 48.761859H72.899001a48.761858 48.761858 0 0 1-48.761858-48.761859v-243.809291z" fill="#FF5630" p-id="7695"></path><path d="M121.66086 536.381417V438.8577l-97.523717 97.523717h97.523717zM901.850593 536.381417l0.975237-97.523717 97.036098 97.523717H901.850593z" fill="#DE350B" p-id="7696"></path><path d="M267.946434 585.143275h84.845634a57.051374 57.051374 0 0 1 41.935198 15.603795 55.1009 55.1009 0 0 1 16.091413 40.959961 55.588518 55.588518 0 0 1-16.091413 40.959961 59.001849 59.001849 0 0 1-43.398054 16.091413h-48.761858v76.556118H267.946434z m32.670446 81.919922h43.885672a42.422817 42.422817 0 0 0 25.843785-6.339041 23.893311 23.893311 0 0 0 7.801897-19.992362q0-24.868548-32.670445-24.868548h-44.860909zM434.71199 588.068987H511.755726a73.142787 73.142787 0 0 1 58.51423 25.356166 100.937047 100.937047 0 0 1 21.942836 68.266602 110.689418 110.689418 0 0 1-20.967599 69.729457A71.679932 71.679932 0 0 1 511.755726 780.190708H434.71199z m32.670445 158.963658H511.755726a43.398054 43.398054 0 0 0 36.083775-17.066651A75.093262 75.093262 0 0 0 560.517584 682.666992a70.704695 70.704695 0 0 0-13.65332-48.761859 48.761858 48.761858 0 0 0-37.546631-16.579031h-41.935198zM755.565018 618.788957h-100.937047v45.348529H755.565018v31.207589h-100.937047v81.919922h-32.670445v-190.171248H755.565018z" fill="#FFFFFF" p-id="7697"></path><path d="M901.850593 312.564487v6.82666h-263.801654a48.761858 48.761858 0 0 1-48.761858-48.761858V0.000975a48.761858 48.761858 0 0 1 34.620919 14.140939l264.289272 263.801654a48.761858 48.761858 0 0 1 13.653321 34.620919z" fill="#C1C7D0" p-id="7698"></path></svg></a></span>
            </div>
          </div>
        </div>
      </div>
    </gui_card>
    <gui_card v-if="AssociationsDate?.length > 0"
      id="ge6845"
      class="uc1096"
      label=""
      :isShowLabel="false"
    >
      <div>
        <h2 class="operations-head-content">
          <span class="operations-head ">{{$t('Sanctions.AssociationList') }}</span>
        </h2>
        <div class="table-biao" >
          <el-table :data="AssociationsDate" style="width: 100%" class="table_height_30 table_font_size_14 table_contentHeight_40">
            <el-table-column
              prop="associationId"
              :label='$t("Sanctions.AssociationID")'
              align="left"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row.associationId }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="Association Type"
              :label='$t("Sanctions.AssociationType")'
              align="left"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row.relation }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              :label='$t("Sanctions.Name")'
              align="left"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span class="table-content">{{ scope.row.name }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </gui_card>
</div>
   
<el-card  v-if="!AssociationsDate&&!sourceItems&&!SanctionData&&!IDData" class="box-card box-cardone " >
 <div class="box-car-content ">
  <div style="width:80%;margin: auto;">
          <h2 class="">
            <img style="height: 9.14285743rem;" src="../../../../assets/images/sactionmenban2.png" alt="">
          <span class="head-titel detail_title_20 margin-bottom20 margin-top20"  style="justify-content: center;">  {{ $t('Sanctions.SeachbuttonNo') }} </span>
        </h2>
     
         <div class="box-card-text margin-bottom30">
         {{ $t('Sanctions.SeachbuttonYes') }}
         </div>
        </div>
         <el-button class="btn_export" style="min-width: 43% !important"  @click="openUrl('/sanction/index')"
      > {{ $t('Sanctions.SearchSanctions') }}</el-button>
 </div>
        </el-card>
        <div  v-else> 
          <el-card   v-if="isMenban" class="box-card box-cardtwo" >
          <div class="box-car-content ">
        <div style="width: 70%;margin: auto;">
          <h2 class="">
            <img style="height: 9.14285743rem;" src="../../../../assets/images/sactionmenban1.png" alt="">
          <span class="head-titel detail_title_20 margin-bottom20 margin-top20" style="justify-content: center;">{{ $t('Sanctions.Potentialcompliance') }} </span>
        </h2>
     
         <div class="box-card-text margin-bottom30">
     {{ $t('Sanctions.SeachbuttonYes') }}
         </div>
        </div>
         <el-button class="btn_export"   @click="isMenban=false"
         >{{ $t('Sanctions.ViewDetails') }}</el-button>
         <!-- https://www.udmlab.com/#/search/searchSanctions?searchname='+ $route.query.companyName+'&companyCountry=&companyCountrydqs=&type=Entity' -->
         <el-button class="btn_export"   @click="openUrl('/sanction/index')"
      >{{ $t('Sanctions.SearchSanctions') }}</el-button>
 </div>
        </el-card>
        </div>
   
        
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
  <!--srcviewscompanydetailsBackgroundSnapshotvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart
import {

getSanctions
} from "@/api/companyApi";
import rectcard from "../../../../components/rectCard/index.vue";
import content_text from "../../../../components/text_content/index.vue";
import gui_card from "../../../../components/gui_card/gui_card.vue";
import tableVue from "../Performance/components/table.vue";
import ReLogin from "../../../../components/ReLogin.vue";
//importEnd

export default {
  name: "",

  props: {},

  components: {
    // gui_card start
    gui_card,
    // gui_card end

    rectcard,
    content_text,
    tableVue,
    ReLogin,
  },

  data() {
    return {
      reLoginVis: false,
      isMenban:true,
      
      EntityData: [],
      NameData: [],
      IDData: [],
      RegisteData: [],
      AddressDate: [],
      sourceItems:[],
       SanctionData: [],
      AssociationsDate:[]
    };
  },
  mounted() {this.getNewsList()},
  methods: {
       formattedString(item) {
            return item.replace(/\n/g, '<br>');
        },
    openUrl(pathUrl) {
         let routeData = this.$router.resolve({
          path: pathUrl,
          query: {
          selectCode:4
          }
        });
        window.open(routeData.href, "_blank");
    },
    getNewsList(){
    let companyName=  JSON.parse(localStorage.getItem('CompanyBase'))?.base?.companyName
      getSanctions({
        id3a: this.$route.query.id3a,
        companyName: encodeURIComponent(companyName)
      }).then(res=>{
      if(res.code == 200){
        this.EntityData=res.data.entityInfos
        this.NameData=res.data.nameInfos
        this.IDData=res.data.idInfos
        this.RegisteData=res.data.countryInfos
        this.AddressDate=res.data.addressInfos
        this.SanctionData=res.data.sanctionItems
        this.sourceItems=res.data.sourceItems
        this.AssociationsDate=res.data.associationItems
        this.$emit('UpdatamarkTotalList',[])
        // this.$emit('UpdatamarkTotalList', JSON.parse( localStorage.getItem(('nineSquareGrid'))))
    //  this.ImporttableData = Res.data.rows
      }else{
        this.EntityData=[]
        this.NameData=[]
        this.IDData=[]
        this.RegisteData=[]
        this.AddressDate=[]
        this.SanctionData=[]
        this.AssociationsDate=[]
        this.$emit('UpdatamarkTotalList',[])
      }
      }).catch(err => {
        this.reLoginVis = String(err).includes('403')
      })
      // getfilterConditions()
    },
  },
  computed: {
    
  },

};
</script>
<style scoped>
 
 .head-titel {
    font-family: "Arial Bold";
  font-size: 26px;
  display: flex;
  align-items: center;
}
.Potential {
  font-size: 26px;
  color: #a2a9b0;
  line-height: 2.142857142857143rem;
  text-align: center;
  font-style: normal;
  margin-top: 1.8571428571428572rem;
}
/deep/ .el-table .cell {
  /* font-size: 1.4285714285714286rem; */
  color: #1a2332;
    font-family: "Arial Bold";
  padding-left: 1.4285714285714286rem !important;
  line-height: 2.142857142857143rem;
}
/deep/ .highlight-cell {
  background-color: #f2f5f9 !important;
}
/deep/ .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
    font-family: "Arial Bold";
}
.head-titeltwo {
  font-size: 18px;
  color: #1290c9;
  line-height: 2.142857142857143rem;
  text-align: left;
  font-style: normal;
  margin: 0.7142857142857143rem 0rem 0;
  font-weight: normal;
}
.Source-left{
  width: 132px;
  line-height: 30px;
  font-size: 20px;
color: #1A2332;
margin-right: 30px;
    font-family: "Arial Bold";
}
.Source-right{
  line-height: 30px;
 font-size: 20px;
color: #1A2332;
flex: 1;
  text-align: justify;
}
.Source-item{
  border-bottom: 0.07142857142857142rem solid #ccc;
}
.Source-height{
  display: flex;
  justify-content: start;
  margin: 2.142857142857143rem 0rem;
}

.uUIRzUi {
  padding: 30px 40px;
}
.box-card{
  background: #FFFFFF;
box-shadow: 0px 2px 14px 0px rgba(0,0,0,0.12);
border-radius: 1.4285714rem;
width:40%;
min-width: 550px;
padding: 1.4285714rem;
text-align: center;
position: absolute;
left: 50%; /* 左边距为50% */
transform: translateX(-50%); /* 向左移动自身宽度的一半 */

top: 30px;
z-index: 9999;
}


.box-card-text   {
  font-size: 1.2857142857142858rem;
color: #666666;
text-align: center;
}
.operations-div{
  position: relative;
opacity: 0.3;
filter: blur(0.125714285714285715rem);
  /* min-height: 25rem; */
}
.company_detail{
  position: relative;
  background-color: #FFFFFF;
}
.box-car-content{
  width: 88%;
  margin: auto;
}
  
  ::v-deep  .el-table th.el-table__cell{
      height: 50px !important;
    }
  ::v-deep .el-table--enable-row-transition .el-table__body td.el-table__cell{
      height: 80px !important; 
    }
  .table-biao{
    margin-top: 20px;
    }
@media (max-width: 1920px) {
  .uUIRzUi {
   padding: 22px 30px;
  } 
  .head-titel { 
    font-size: 20px;
  }
  .head-titeltwo {
    font-size: 16px;
  }
  ::v-deep  .el-table th.el-table__cell{
    height: 44px !important;
  }
  ::v-deep .el-table--enable-row-transition .el-table__body td.el-table__cell{
      height: 50px !important; 
    } 
  .table-content {
    font-size: 16px !important;
  }
    
.Source-left{
  width: 100px;
  line-height: 22px;
  font-size: 16px; 
margin-right: 22px; 
}
.Source-right{
  line-height: 22px;
 font-size: 16px; 
}
  .table-biao{
    margin-top: 16px;
    }
    .btn_export{ 
    min-width: 90px;
        height: 36px;
    border-radius: 8px;
    font-size: 16px;
    line-height: 16px;
  }
}

@media (max-width: 1439px) {
  .uUIRzUi {
  padding: 20px 26px;
  }
  .head-titel { 
    font-size: 18px;
  }
  .head-titeltwo {
    font-size: 12px;
  }
  ::v-deep  .el-table th.el-table__cell{
    height: 34px !important;
  }
  ::v-deep .el-table--enable-row-transition .el-table__body td.el-table__cell{
      height: 54px !important; 
    }

.Source-left{
  width: 88px;
  line-height: 20px;
  font-size: 12px; 
margin-right: 20px; 
}
.Source-right{
  line-height: 20px;
 font-size: 12px; 
}
  .table-biao{
    margin-top: 14px;
    }
}
</style>
